import { render } from "./Main-Navbar-Button.vue?vue&type=template&id=cd227a9a&scoped=true"
import script from "./Main-Navbar-Button.vue?vue&type=script&lang=js"
export * from "./Main-Navbar-Button.vue?vue&type=script&lang=js"

import "./Main-Navbar-Button.vue?vue&type=style&index=0&id=cd227a9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd227a9a"]])

export default __exports__